import { render, staticRenderFns } from "./TimestampingServiceRow.vue?vue&type=template&id=dc3a04a2&scoped=true&"
import script from "./TimestampingServiceRow.vue?vue&type=script&lang=ts&"
export * from "./TimestampingServiceRow.vue?vue&type=script&lang=ts&"
import style0 from "./TimestampingServiceRow.vue?vue&type=style&index=0&id=dc3a04a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc3a04a2",
  null
  
)

export default component.exports